export const contactImages = {
  people_add_user: 'assets/img/peoples-add-user.svg',
  contact_task: 'assets/img/graphics/Task-icon.svg',
  contact_stream: 'assets/img/menuIcon/stream_icon.svg',
  contact_contract: 'assets/img/light-document.svg',
  related_contact: 'assets/img/graphics/Contact.svg',
  user_circle_icon: 'assets/img/menuIcon/user_circle.svg',
  history_icon: 'assets/img/menuIcon/history.svg',
  contact_1_icon: 'assets/menu-customisation-icons/Contact/contact1.svg',
  contact_2_icon: 'assets/menu-customisation-icons/Contact/contact2.svg',
  contact_4_icon: 'assets/menu-customisation-icons/Contact/contact4.svg',
  contact_6_icon: 'assets/menu-customisation-icons/Contact/contact6.svg',
  contact_7_icon: 'assets/menu-customisation-icons/Contact/contact7.svg',
  contact_9_icon: 'assets/menu-customisation-icons/Contact/contact9.svg',
  contact_10_icon: 'assets/menu-customisation-icons/Contact/contact10.svg',
  contact_11_icon: 'assets/menu-customisation-icons/Contact/contact11.svg',
  contact_16_icon: 'assets/menu-customisation-icons/Contact/contact16.svg',
};
